module.exports = __webpack_public_path__ + "static/high-five-ff4bf23a3e1de6e523560e0c2365a698.png";